<template>
    <div style="width: 100%; height: 100%">
        <CCBlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: false, code: 'articel' }">
            <div v-if="listData.length" class="ImageText">
                <div class="image" @click.stop="btnFn(listData[0])">
                    <!-- <img src="images/w-imgs/index/01.png" alt="" style="width: 100%;" fit="cover"> -->
                    <img v-if="!interfaceStatus" style="cursor: pointer" :src="`/apigw/portal/cms/article/download?dataField=logoData&nameField=logoName&id=${listData[0].id}&httpPort=9528`" alt="" />
                    <el-image v-else style="width: 100%; height: 100%; object-fit: contain; position: relative">
                        <div slot="error" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)" class="image-slot">
                            <!-- <i style="font-size: 32px;" class="el-icon-picture-outline"></i> -->
                            <svg-icon style="font-size: 52px" icon-class="tupian" />
                        </div>
                    </el-image>
                    <div style="cursor: pointer" class="one" @click.stop="btnFn(listData[0])">
                        <div style="font-size: 18px; height: 21px; line-height: 21px; cursor: pointer; padding-left: 15px; margin-top: 10px" class="title">{{ listData[0].title }}</div>
                        <div class="make" v-html="listData[0].content"></div>
                        <div class="make">
                            <span>{{ listData[0].cateName }} &nbsp;&nbsp; {{ listData[0].publishTime ? listData[0].publishTime.split(' ')[0] : '' }}</span>
                        </div>
                    </div>
                </div>
                <div class="textlist">
                    <div class="list">
                        <div v-for="(item, index) in listData" :key="item.id" class="link-message bor">
                            <div v-if="index != 0" class="list_content" style="display: flex; height: 42px; line-height: 42px; justify-content: space-between; padding: 0 5px" @click.stop="btnFn(item)">
                                <div class="flex1 text-no">{{ item.title }}</div>
                                <div style="text-align: right">{{ item.publishTime }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="block-head-more" @click.stop="gotoPages()">更多<i class="el-icon-d-arrow-right" /></div>
        </div> -->
                </div>
            </div>
            <div v-else style="text-align: center; padding-top: 100px">
                <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                <br />
                <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
            </div>
        </CCBlockFrame>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        title: { type: String, default: '' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            listData: [],
            interfaceStatus: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getData()
    },
    beforeDestroy() {},
    mounted() {
        this.title = this.title || this.$tx('ecoa.portal.fileManeger', '文章管理')
    },
    methods: {
        // gotoDetail() {
        //     this.$router.push({ path: '/lm/daa0c91fdf17400eb832cd2d2aede285/2c6750800d4e480391c433cfaa129d22/390edd14d34a47189725286935d8d1e2' })
        // },
        btnFn(row) {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.$bus.emit('openDefaultDialog', this.appletData.name)
                return
            }
            sessionStorage.removeItem('gotoType')
            this.$emit('openListInfo', row)
            const activeItem = {
                name: '新闻',
                type: 2,
                moduleInfo: { getByIdUrl: 'portal/cms/article/getById' },
                fieldInfo: { timeField: 'publishTime', senderField: 'creator', titleField: 'title', contField: 'content', readNum: 'readNum' },
                desInfo: { timeDes: '发布时间：', senderDes: '发布人：' }
            }
            if (row.id) {
                window.open('/#/commonHeader?workform=@/wapp/xxfb/article/components/CCViewContent&background=false&wflowType=getById&wfEngineUrl=portal/cms/article&busiDataId=' + row.id + '&viewContent=1' + '&type=zsgl&logoTitle=' + encodeURIComponent(`信息共享/新闻中心`))
            }
        },
        async getData() {
            if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                this.interfaceStatus = true
                const list = await this.$getDefaultData(this, this.appletData.id)

                if (this.appletData.name === '集团新闻') {
                    this.listData = list
                    return
                }
            }
            this.$http({
                url: '/portal/cms/article/listdata',
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    pageNum: 1,
                    pageSize: 9,
                    orderBy: 'isHeadlines desc,publishTime desc',
                    urlsearch: `type:1;deleteStatus:0;publishStatus: 1;reviewStatus!:2`
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.listData = res.body.pageInfo.list
                    console.log(this.listData, '集团新闻')
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.ImageText {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 8px 10px;
    .image {
        width: 400px;
        height: calc(400px / 1.778);
        // padding: 10px 15px;
        img {
            width: 400px;
            height: calc(400px / 1.778);
            object-fit: cover;
        }
    }
    .textlist {
        padding-left: 25px;
        width: calc(100% - 400px);
        // height: 100px;
        padding-left: 10px;
        cursor: pointer;
        .title {
            font-size: 16px;
            color: #333333;
            line-height: 1.5;
            margin-top: 10px;
            margin-bottom: 4px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }

        .time {
            font-size: var(--portalFontSize14);
            color: #999999;
            margin: 10px 0;
        }
        .one {
            height: 170px;
            cursor: pointer;
            position: absolute;
            bottom: 20px;
            left: 10px;
            width: 50%;
        }
        .list {
            .list_content {
                display: flex;
                cursor: pointer;

                .title {
                    width: calc(100% - 90px);
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    line-height: 43px;
                    margin: 0;
                    font-size: var(--portalFontSize14);
                }
                .time {
                    width: 90px;
                    line-height: 24px;
                    text-align: center;
                }
            }
        }
    }
}
.bor {
    border-bottom: 1px dashed #ebeef5;
}
.bor:first-child {
    border-bottom: none !important;
}
.bor:last-child {
    border-bottom: none !important;
}
.block-head-more {
    cursor: pointer;
    font-size: var(--portalFontSize12);
    color: #999999;
    height: 45px;
    line-height: 25px;
    text-align: right;
    position: absolute;
    top: 10px;
    right: 10px;
}
.title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.make {
    // margin-top: 15px;
    font-size: var(--portalFontSize14);
    color: #999999;
    line-height: 20px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: rgb(153, 153, 153);
    cursor: pointer;
    padding-left: 15px;
    padding-top: 5px;
}
</style>
